<template>
  <div class="sf-full-width">
    <select ref="select2" class="user-select sf-form-select" :name="name">
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  name: 'SfSelect2',
  props: ['options', 'modelValue', 'configuration', 'name'],
  emits: ['update:modelValue'],
  watch: {
    modelValue(modelValue) {
      window.$(this.$refs.select2.value).val(modelValue).trigger('change')
    },
  },

  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this
    // select2 is injected from sprockets, so we need to use the jQuery globally
    // defined. If we add the jQuery import here, select2 will no longer be present;
    // the only reason we need to use window.$ is because the linter complains
    // with a "'$' is not defined" error.
    const $select2 = window.$(this.$refs.select2)

    $select2.select2(this.configuration).val(this.modelValue)
    $select2.on('change', function () {
      nextTick(() => {
        vm.$emit('update:modelValue', this.value)
      })
    })
    $select2.trigger('change')
  },

  beforeUnmount() {
    window.$(this.$refs.select2.value).select2('close').select2('destroy')
  },
}
</script>
